var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4567_2090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0.666016H3.33333C2.4496 0.667074 1.60237 1.0186 0.97748 1.6435C0.352588 2.26839 0.00105857 3.11562 0 3.99935L0 11.9993C0.00105857 12.8831 0.352588 13.7303 0.97748 14.3552C1.60237 14.9801 2.4496 15.3316 3.33333 15.3327H12.6667C13.5504 15.3316 14.3976 14.9801 15.0225 14.3552C15.6474 13.7303 15.9989 12.8831 16 11.9993V3.99935C15.9989 3.11562 15.6474 2.26839 15.0225 1.6435C14.3976 1.0186 13.5504 0.667074 12.6667 0.666016ZM3.33333 1.99935H12.6667C13.0659 2.00013 13.4557 2.12036 13.786 2.34455C14.1163 2.56874 14.3719 2.88665 14.52 3.25735L9.41467 8.36335C9.03895 8.73756 8.53028 8.94766 8 8.94766C7.46972 8.94766 6.96105 8.73756 6.58533 8.36335L1.48 3.25735C1.6281 2.88665 1.88374 2.56874 2.21403 2.34455C2.54432 2.12036 2.93414 2.00013 3.33333 1.99935ZM12.6667 13.9993H3.33333C2.8029 13.9993 2.29419 13.7886 1.91912 13.4136C1.54405 13.0385 1.33333 12.5298 1.33333 11.9993V4.99935L5.64267 9.30602C6.26842 9.93019 7.11617 10.2807 8 10.2807C8.88383 10.2807 9.73158 9.93019 10.3573 9.30602L14.6667 4.99935V11.9993C14.6667 12.5298 14.456 13.0385 14.0809 13.4136C13.7058 13.7886 13.1971 13.9993 12.6667 13.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4567_2090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMailIcon);
export default __webpack_public_path__ + "static/media/Bg_mail_icon.4c21edbe7ef50076756771e52cdf0214.svg";
export { ForwardRef as ReactComponent };